/* eslint-disable */
import React, { Component } from "react";
import MediaQuery from "react-responsive";
import Header from "../../components/Header";
import Category from "../../components/Category";
import IconButton from "../../components/IconButton";

import "./index.css";

const work = [
  {
    header: "Stripe",
    info: "Software Engineering Intern",
    a: "https://stripe.com/",
  },
  {
    header: "Instagram",
    info: "Software Engineering Intern",
    a: "https://www.instagram.com",
  },
  {
    header: "Pinterest",
    info: "Software Engineering Intern",
    a: "https://www.pinterest.com",
  },
  {
    header: "Nextdoor",
    info: "Software Engineering Intern",
    a: "https://nextdoor.com",
  },
  {
    header: "TutorOcean",
    info: "Co-Founder",
    a: "https://www.tutorocean.com/",
  },
  {
    header: "Nokia",
    info: "Software Designer Intern",
    a: "https://www.nokia.com/en_int",
  },
];

const links = [
  {
    header: "Instagram",
    info: "arlen.yu",
    a: "https://www.instagram.com/arlen.yu/",
  },
  {
    header: "Github",
    info: "arlen-yu",
    a: "https://github.com/arlen-yu",
  },
];

const playlists = [
  {
    header: "My go-to",
    info: "Just hit shuffle and enjoy",
    a:
      "https://open.spotify.com/user/a.rlenyu/playlist/0VImt9tiTqXwtJzoqRAgJK?si=9JtAIDacSCeUP6XLXvTDtg",
  },
  {
    header: "Hyperfocused",
    info: "A study playlist",
    a:
      "https://open.spotify.com/user/a.rlenyu/playlist/6KsoveRkeqqG9OmkPcsKfr?si=82wKeJCEQWGQ2snXcuy-Aw",
  },
  {
    header: "Workout",
    info: "Volume up",
    a:
      "https://open.spotify.com/user/a.rlenyu/playlist/0aTLh7mgkvOBAZzSWix3S7?si=97IZS2IvTFaJ2uEuXTjVng",
  },
];

const projects = [
  {
    header: "Spotivibe",
    info: "Queries energy & dancability of music",
    a: "https://github.com/arlen-yu/spotivibe",
  },
  {
    header: "Phill Good",
    info: "Checks if its safe to go outside",
    a: "https://github.com/arlen-yu/phill-good",
  },
];

const notes = [
  {
    header: "CS246",
    info: "With Brad Lushman",
    a: "https://github.com/arlen-yu/cs246",
  },
  {
    header: "CS241",
    info: "With Nomair",
    a: "https://github.com/arlen-yu/cs241",
  },
];

const workshops = [
  {
    header: "Equithon 2018",
    info: "Intro to React.js",
    a: "/equithon-react-slides",
  },
];

class App extends Component {
  renderLink = (child) => {
    return <div style={{ padding: "0 10px", fontSize: 14 }}>{child}</div>;
  };

  linkify = (link, color, text) => {
    return (
      <a href={link} style={{ color }} target="_blank">
        {text}
      </a>
    );
  };

  render() {
    return (
      <div>
        <div className="blurb">
          <p>
            Find me by{" "}
            {this.linkify("mailto:arlen.yu6@gmail.com", "#ff7f50", "Email")} or
            on{" "}
            {this.linkify(
              "https://www.linkedin.com/in/arlen-yu/",
              "#0077B5",
              "LinkedIn"
            )}
            , {this.linkify("https://m.me/arlen.yu6", "#0084ff", "Messenger")},
            or{" "}
            {this.linkify("https://github.com/arlen-yu", "#6e5494", "Github")}.
          </p>
        </div>
        <div className="categories">
          <MediaQuery query={"(min-width: 640px)"}>
            {(matches) => {
              if (matches) {
                return [
                  <div className="column" key={1}>
                    <Category header="Work" items={work} />
                  </div>,
                  <div className="column" key={2}>
                    <Category header="Workshops" items={workshops} />
                    <Category header="Links" items={links} />
                  </div>,
                  <div className="column" key={3}>
                    <Category header="Projects" items={projects} />
                    <Category header="Notes" items={notes} />
                    {/* <Category header="Playlists" items={playlists} /> */}
                  </div>,
                ];
              }

              return (
                <MediaQuery query="(min-width: 440px)">
                  {(m) => {
                    if (m) {
                      return [
                        <div className="column" key={1}>
                          <Category header="Work" items={work} />
                          <Category header="Notes" items={notes} />
                          <Category header="Playlists" items={playlists} />
                        </div>,
                        <div className="column" key={2}>
                          <Category header="Projects" items={projects} />
                          <Category header="Links" items={links} />
                          <Category header="Workshops" items={workshops} />
                        </div>,
                      ];
                    }
                    return (
                      <div className="column">
                        <Category header="Work" items={work} />
                        <Category header="Projects" items={projects} />
                        <Category header="Links" items={links} />
                        <Category header="Notes" items={notes} />
                        <Category header="Workshops" items={workshops} />
                        <Category header="Playlists" items={playlists} />
                      </div>
                    );
                  }}
                </MediaQuery>
              );
            }}
          </MediaQuery>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/pages/Home/index.js